import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import React, { Fragment, useCallback, useEffect } from "react";
import TableCM from "components/shared/Table";
import { Grid, IconButton, TextField, Tooltip } from "@mui/material";
import PaginationCM from "components/shared/Pagination";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import { useState } from "react";
import { getAttendaceRequest } from "api/requests";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import { PAGINATION_LIMIT } from "constants";
import {
  StyledDateBox,
  StyledGridIcons,
  StyledStack,
} from "./DisplayAttendance.style";
import DatePickerCM from "components/shared/DatePicker";
import { convertNum } from "helper/convert-num";
import { useForm } from "react-hook-form";
import { Delete, FilterAlt } from "@mui/icons-material";

const headCells = GenarateHeadCell("teacher_attendance");

export default function TeacherAttendance() {
  const { loading, request, setLoading } = useHttp();

  //paginition state
  const [page, setPage] = useState(1);

  // class attendance list state
  const [attendance, setAttendance] = useState({ data: [], count: 0 });

  const { class_id } = useParams();
  const navigate = useNavigate();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const { register } = useForm();

  // date filter handler
  const onFromDateHandler = (value) =>
    setFromDate(
      value
        .format("YYYY-MM-DD")
        .split("-")
        .map((item) => convertNum(item))
        .join("-")
    );

  const onToDateHandler = (value) =>
    setToDate(
      value
        .format("YYYY-MM-DD")
        .split("-")
        .map((item) => convertNum(item))
        .join("-")
    );

  // get class attendance list
  const getAttendance = async (filter = true) => {
    const query = {
      skip: (page - 1) * PAGINATION_LIMIT,
      limit: PAGINATION_LIMIT,
      from_date: fromDate ?? null,
      to_date: toDate ?? null,
      class_id,
    };

    const res = await request({
      url: getAttendaceRequest,
      values: filter
        ? query
        : {
            class_id,
            skip: (page - 1) * PAGINATION_LIMIT,
            limit: PAGINATION_LIMIT,
          },
    });
    if (res.count < 1) {
      return setAttendance({
        count: res.count,
        data: [{ content: "هیچ حضور و غیابی یافت نشد" }],
      });
    }
    setLoading(false);

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items?.class?.course?.title ?? "ثبت نشده",
        date: items?.date?.string ?? "ثبت نشده",
        level: items?.class?.level ?? "ثبت نشده",
        educational_year: items?.class?.educational_year ?? "ثبت نشده",
      }));
      setAttendance({ data: transformedData, count: res.count });
    }
  };

  const getWithFilter = () => {
    setPage(1);
    getAttendance();
  };

  const getWithoutFilter = () => {
    setPage(1);
    setFromDate("");
    setToDate("");
    getAttendance(false);
  };

  useEffect(() => {
    getAttendance();
  }, [page]);

  return (
    <DrawerCM title="لیست حضور و غیاب" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2} spacing={1}>
            <Grid container my={2}>
              <Grid item xs={12}>
                <BackButton Route={"/teacher_classes"} />
              </Grid>
            </Grid>
            <StyledStack>
              <Grid container>
                <Grid item sm={5} xs={12} py={1} px={1}>
                  <StyledDateBox>
                    <DatePickerCM
                      onChange={onFromDateHandler}
                      render={(value, openCalendar) => {
                        return (
                          <TextField
                            label="از تاریخ"
                            variant="outlined"
                            fullWidth
                            size="small"
                            id="from_created_at"
                            {...register("from_created_at")}
                            value={
                              fromDate ? fromDate.split("-").join("/") : ""
                            }
                            onClick={openCalendar}
                          />
                        );
                      }}
                    />
                  </StyledDateBox>
                </Grid>
                <Grid item sm={5} xs={12} p={1}>
                  <StyledDateBox>
                    <DatePickerCM
                      onChange={onToDateHandler}
                      render={(value, openCalendar) => {
                        return (
                          <TextField
                            label="تا تاریخ"
                            variant="outlined"
                            fullWidth
                            size="small"
                            id="to_created_at"
                            {...register("to_created_at")}
                            value={toDate ? toDate.split("-").join("/") : ""}
                            onClick={openCalendar}
                          />
                        );
                      }}
                    />
                  </StyledDateBox>
                </Grid>
                <StyledGridIcons item sm={2} xs={12} p={1}>
                  <IconButton color="primary" onClick={getWithFilter}>
                    <Tooltip title="اعمال فیلتر" placement="top">
                      <FilterAlt />
                    </Tooltip>
                  </IconButton>
                  <IconButton color="error" onClick={getWithoutFilter}>
                    <Tooltip title="حذف فیلتر" placement="top">
                      <Delete />
                    </Tooltip>
                  </IconButton>
                </StyledGridIcons>
              </Grid>
            </StyledStack>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست حضور و غیاب ها"
                rows={attendance.data}
                headCells={headCells}
                addAttendance={class_id}
                Id={class_id}
                page={page}
                click={(attId) =>
                  navigate("/teacher_class/attendance/" + attId + "/edit")
                }
              />
            </Grid>
            <Grid
              container
              spacing={0}
              alignItems="center"
              justifyContent="center"
            >
              {attendance.data.length < 1 ? (
                ""
              ) : (
                <PaginationCM
                  handleChange={(_, val) => setPage(val)}
                  page={page}
                  count={attendance.count}
                />
              )}
            </Grid>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
